// Admin configuration
export const ADMIN_CONFIG = {
  // Super admin email (highest level access)
  SUPER_ADMIN_EMAIL: 'aaron@saycoo.com',

  // Admin role levels
  ROLES: {
    SUPER_ADMIN: 'super_admin',
    ADMIN: 'admin',
    USER: 'user'
  } as const,

  // Permissions
  PERMISSIONS: {
    MANAGE_USERS: 'manage_users',
    VIEW_ADMIN_PANEL: 'view_admin_panel',
    MANAGE_SYSTEM: 'manage_system',
    VIEW_DASHBOARD: 'view_dashboard'
  } as const,

  // Will be populated below
  ROLE_PERMISSIONS: {} as Record<string, string[]>
};

export type UserRole = typeof ADMIN_CONFIG.ROLES[keyof typeof ADMIN_CONFIG.ROLES];
export type Permission = typeof ADMIN_CONFIG.PERMISSIONS[keyof typeof ADMIN_CONFIG.PERMISSIONS];

// Role permissions mapping
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  [ADMIN_CONFIG.ROLES.SUPER_ADMIN]: [
    ADMIN_CONFIG.PERMISSIONS.MANAGE_USERS,
    ADMIN_CONFIG.PERMISSIONS.VIEW_ADMIN_PANEL,
    ADMIN_CONFIG.PERMISSIONS.MANAGE_SYSTEM,
    ADMIN_CONFIG.PERMISSIONS.VIEW_DASHBOARD
  ],
  [ADMIN_CONFIG.ROLES.ADMIN]: [
    ADMIN_CONFIG.PERMISSIONS.MANAGE_USERS,
    ADMIN_CONFIG.PERMISSIONS.VIEW_ADMIN_PANEL,
    ADMIN_CONFIG.PERMISSIONS.VIEW_DASHBOARD
  ],
  [ADMIN_CONFIG.ROLES.USER]: [
    ADMIN_CONFIG.PERMISSIONS.VIEW_DASHBOARD
  ]
};

// Add ROLE_PERMISSIONS to ADMIN_CONFIG for easier access
ADMIN_CONFIG.ROLE_PERMISSIONS = ROLE_PERMISSIONS;

export const hasPermission = (userRole: UserRole, permission: Permission): boolean => {
  return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
};

export const isSuperAdmin = (email: string): boolean => {
  return email.toLowerCase() === ADMIN_CONFIG.SUPER_ADMIN_EMAIL.toLowerCase();
};